import React from 'react';
import { useState } from 'react';
import { useLocation, useNavigate, Link } from 'react-router-dom'
import Background from '../../../../../static/img/bg-select.png';
import { Breadcrumb, Row, Col, Spin, Card, Typography, List } from 'antd';
import {
    OpenAPIDeveloperAppList
} from "../gqls";
import Client from '../../../../../lib/gqlClient';
import AppDeveloperChartPage from './chart'
const AppTrend = (props) => {
    const navigate = useNavigate();
    const location = useLocation()
    const { state } = location
    const appId = state.appUserId

    const [page, setPage] = useState(1)
    const [showSize, setShowSize] = useState(8)
    const [isGetData, setIsGetData] = useState(false)
    const [total, setTotal] = useState(1)
    const [dataList, setDataList] = useState([])
    const [solutionsList,setSolutionsList] = useState([])
    const { Paragraph, Text } = Typography;
    React.useEffect(() => {
        console.log('appId:', appId)
        getOpenAPIDeveloperAppList(page,showSize)
        window.history.pushState(null, null, document.URL);
        window.onpopstate = function (PopStateEvent) {
            window.history.pushState(null, null, document.URL);
            onStartDeveloper()
        };
        return () => {
            // 回退事件只用于当前组件，则需要在组件销毁时把回退事件销毁
            window.onpopstate = null;
        };
    }, [])
  
    function onStart() {
        props.setNewKey('developerCenter/apiDataNoticfication')
        navigate('/developerCenter/apiDataNoticfication')

    }
    function onStartDeveloper() {
        props.setNewKey('developerCenter/developer')
        navigate('/developerCenter/developer', {
            replace: false, 
            state: {
              seatchData: state.seatchData,
              page: state.page,
              showSize: state.showSize
            }
          })

    }
    function getOpenAPIDeveloperAppList(page, count) {
        setIsGetData(true)
        if (count !== showSize) {
            setShowSize(count)
        }
        Client(
            OpenAPIDeveloperAppList,
            {
                appUserId: appId,
                count: count,
                page: page,
            }
        ).then((res) => {
            console.log(res)
            if (res !== null) {
                let list = [""];
                res.data.openAPIDeveloperAppList.data.map((item, index) => {
                    let solutions = ''
                    item.solutions.map((item2, index2) => {
                        if (solutions === "") {
                            solutions = item2
                        } else {
                            solutions = solutions + "\n" + item2
                        }
                    })
                    list[index] = solutions
                })
                setSolutionsList(list)
                setDataList(res.data.openAPIDeveloperAppList.data)
                setTotal(res.data.openAPIDeveloperAppList.total)
            }
            setIsGetData(false)
        }).catch(e => {
            // console.log(e);
            setIsGetData(false)
        })
    }

    return (
        <div style={{ height: '100%', width: '100%', }}>
            {/* 标题头 */}
            <div style={{ height: '503px', padding: '0px', backgroundColor: 'white', borderRadius: '2px' }}>
                <Breadcrumb style={{ marginLeft: '20px', paddingTop: "6px" }}>
                    <Breadcrumb.Item><Link to='../../../../home' style={{ fontSize: '12px' }}>首页</Link></Breadcrumb.Item>
                    <Breadcrumb.Item><a onClick={onStart} style={{ fontSize: '12px' }}>API Dashboard</a></Breadcrumb.Item>
                    <Breadcrumb.Item><a onClick={onStartDeveloper} style={{ fontSize: '12px' }}>开发者列表</a></Breadcrumb.Item>
                    <Breadcrumb.Item><a style={{ fontSize: '12px' }}>开发者名下所有App使用情况</a></Breadcrumb.Item>
                </Breadcrumb>
                <li style={{ textAlign: 'center', marginTop: '8px', display: 'block', fontSize: '16px', lineHeight: '24px', color: ' #000' }}>
                    开发者名下所有App使用趋势</li>
                <AppDeveloperChartPage
                    appUserId={appId} />
            </div>
            <Card bordered={false} style={{ marginTop: '25px', marginBottom: '25px', padding: '0px', }}>
                <div style={Styles.listTitle}>开发者名下所有App详情</div>
                <Row style={Styles.listTitleBg}>
                    <Col span={5} style={Styles.listTitleText}>
                        App Name
                    </Col>
                    <Col span={7} style={Styles.listTitleText}>
                        Client ID
                    </Col>
                    <Col span={4} style={Styles.listTitleText}>
                        Solutions
                    </Col>
                    <Col span={4} style={Styles.listTitleText}>
                        Expired Time
                    </Col>
                    <Col span={4} style={Styles.listTitleText}>
                        Last Change Time
                    </Col>
                </Row>
                <Spin size="large" tip="Loading..." spinning={isGetData}>

                    <List
                        itemLayout="vertical"
                        split="true"
                        pagination={{
                            onChange: (page, pageSize) => {
                                console.log(page);
                                setPage(page)
                                getOpenAPIDeveloperAppList(page, pageSize)
                            },
                            pageSize: showSize,
                            hideOnSinglePage: true,
                            pageSizeOptions: [8, 10, 15, 20, 30, 50, 80, 100],
                            current: page,
                            total: total

                        }}
                        position="bottom"
                        dataSource={dataList}
                        renderItem={(item, index) => (
                            <List.Item>
                                <Row style={Styles.item}>
                                    <Col span={5} style={Styles.listTitleText}>
                                        {item.appName}
                                    </Col>
                                    <Col span={7} style={Styles.listTitleText}>
                                        {item.clientId}
                                    </Col>
                                    <Col span={4} style={Styles.listTitleText}>
                                        <Paragraph
                                            style={{ whiteSpace: 'pre-line' }}
                                            ellipsis={{
                                                symbol: 'more',
                                            }}
                                        >{solutionsList[index]}</Paragraph>
                                    </Col>
                                    <Col span={4} style={Styles.listTitleText}>
                                        {item.expiredTime.substring(0, 10) + " " + item.expiredTime.substring(11, 19)}
                                    </Col>
                                    <Col span={4} style={Styles.listTitleText}>
                                        {item.lastChangeTime.substring(0, 10) + " " + item.lastChangeTime.substring(11, 19)}
                                    </Col>
                                </Row>
                            </List.Item>
                        )}
                    />
                </Spin>
            </Card>
        </div>
    );
}
function getItem(label, key,) {
    return {
        key,
        label,
    };
}
const items = [
    getItem('总使用设备数', '1'),
    getItem('总测量数据', '2'),
];
const Styles = {
    listTitleBg: {
        height: '54px',
        padding: '0px',
        backgroundColor: '#F3F3F3',
        borderRadius: '2px',
        marginTop: '10px',
    },
    listTitleText: {
        fontSize: '14px',
        lineHeight: '22px',
        display: 'flex',
        alignItems: 'center',
        paddingLeft: '30px'
    },
    selectBg: {
        backgroundImage: `url(${Background})`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: '100%, 100%',
        marginRight: '32px',
        paddingTop: '5px',
        paddingBottom: '5px',
        height: '32px',
        width: '256px',
        color: '#000'
    },
    item: {
        height: '54px',
        backgroundRepeat: 'no-repeat',
        backgroundSize: '100%, 100%',
    }, listTitle: {
        display: 'block',
        fontSize: '16px',
        color: '#000000',
        marginTop: '25px',
        textAlign: 'center'

    }
}
export default AppTrend